import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { EventsService } from './eventsService';
import { AppConfigService } from './appConfigService';
import { MessageAlert } from '../_modals/message-alert/message-alert';
import { DataService } from './data.service';
import { DialogService } from './dialog.service';
import { AuthenticationService } from './authenticationService';
import { EnterPinFormComponent } from '../_modals/enter-pin-form/enter-pin-form.component';
import { AppStateService } from './state.service';
import { UtilityService } from './utility.service';
import { CommonService } from './common.service';
import { Config } from '../_store/config';
// This service kind of acts like interface for other controllers to show dialogs
// It knows lots about components at the moment, that can be moved to configs or respective services

@Injectable({
    providedIn: 'root'
})
export class SellerLogoManagerService {

    logoMap = {
        'default': {
            path: 'assets/icon/default_cpg.png',
        }
    }


    constructor(
        authService: AuthenticationService,
        private utilityService: UtilityService,
        private commonService: CommonService
    ) {
        setTimeout(() => {
            if (authService.currentUser) {
                authService.currentUser.subscribe(x => {
                    console.log('Change in auth');
                });
            }
        }, 100);
    }


    initLogo(logoPath) {
        if (!this.getLogoObj(logoPath)) {
            this.logoMap[logoPath] = {
                elementClass: this.commonService.generateRandomString(10)
            };
        }
        const logoObj: any = this.initLogoObj(logoPath);
        return logoObj;
    }

    private initLogoObj(logoPath) {
        const logoObj = this.getLogoObj(logoPath);
        if (!logoObj.logoRetrievedOverHTTP && !logoObj.logoQueued) {
            logoObj.path = this.logoMap.default.path;
            logoObj.logoQueued = true;
            this.requestSellerLogoOverHTTP(logoPath).subscribe(() => {
                this.updateLogoImage(logoPath, logoObj.elementClass);
                logoObj.path = logoPath;
                logoObj.logoRetrievedOverHTTP = true;
                logoObj.logoQueued = false
            }, (err) => {
                logoObj.logoRetrievedOverHTTP = true;
                logoObj.logoQueued = false
            }, () => {
                logoObj.logoRetrievedOverHTTP = true;
                logoObj.logoQueued = false
            });
        } else {
            if (!logoObj.path) {
                logoObj.path = this.logoMap.default.path;
            }
        }
        return logoObj;
    }

    getLogoObj(logoPath) {
        return this.logoMap[logoPath];
    }


    private requestSellerLogoOverHTTP(logoPath) {
        if (Config.useProxyForLogo) {
            return this.utilityService.httpGetLocal(`${Config.proxyForLogoURL}${encodeURIComponent(logoPath)}`, {
                responseType: 'blob'
            });
        } else {
            return this.utilityService.httpGetLocal(logoPath, {
                responseType: 'blob'
            });
        }
    }


    //TODO
    //DOM Code - needs to be part of separate directive
    private updateLogoImage(logoPath, className) {
        const sellerLogoElements: any = document.getElementsByClassName(className);
        for (let i = 0; i <= sellerLogoElements.length - 1; i++) {
            const elem = sellerLogoElements[i];
            elem.src = logoPath
            setTimeout(() => {
                elem.classList.remove(className);
            }, 1000);
        };
    }


}


